import { useEffect, useState } from "react";
import { useI18n } from "../context/I18nContext";

const DISMISS_KEY = "co_ios_banner_dismissed_v2";

function isIosUserAgent() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  // Covers iPhone, iPad, iPod + iPadOS 13+ (which masquerades as Mac with touch)
  const ipadOSMasquerading = /Macintosh/.test(ua) && "ontouchend" in document;
  return /iPad|iPhone|iPod/.test(ua) || ipadOSMasquerading;
}

/**
 * iPhone-only "Add to Home Screen" tip.  Since there's no iOS App Store
 * version planned, this banner instead tells iPhone visitors how to pin
 * canadianopinions.ca to their home screen so it opens like an app.
 */
export default function IosComingSoonBanner() {
  const { t } = useI18n();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isIosUserAgent()) return;
    try {
      if (localStorage.getItem(DISMISS_KEY)) return;
    } catch {/* ignore (private mode) */}
    setShow(true);
  }, []);

  if (!show) return null;

  const dismiss = () => {
    setShow(false);
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch { /* ignore */ }
  };

  return (
    <div
      className="fixed bottom-3 left-3 right-3 sm:bottom-5 sm:left-auto sm:right-5 sm:max-w-md z-50 bg-white border-2 border-black p-4 sm:p-5 brutal-shadow-red"
      data-testid="ios-coming-soon-banner"
      role="dialog"
      aria-labelledby="ios-banner-title"
    >
      <div className="flex items-start gap-3">
        <div className="shrink-0 mt-1 w-7 h-7 bg-black text-white flex items-center justify-center font-mono-civic text-xs" style={{ fontWeight: 900 }} aria-hidden>
          
        </div>
        <div className="flex-1 min-w-0">
          <h3
            id="ios-banner-title"
            className="font-mono-civic text-xs uppercase tracking-[0.2em] text-black"
            style={{ fontWeight: 900 }}
            data-testid="ios-banner-title"
          >
            {t("ios_banner_title")}
          </h3>
          <p className="mt-1.5 text-black text-sm leading-snug" style={{ fontWeight: 600 }}>
            {t("ios_banner_body")}
          </p>
          <div className="mt-3 flex items-center gap-3 flex-wrap">
            <button
              type="button"
              onClick={dismiss}
              className="bg-black text-white uppercase tracking-widest px-3 py-2 border-2 border-black text-xs hover:bg-white hover:text-black transition-colors"
              style={{ fontWeight: 900 }}
              data-testid="ios-banner-cta"
            >
              {t("ios_banner_cta")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
